import React from 'react';

import CallToAction from '../../CallToAction';
import GatsbyImage from '../../Image/GatsbyImage';
import VideoComponent from '../../Video';

import { renderHeaderMedia, renderHeaderText } from '../utils/renderUtils';
import parseGradientText from '../../../utils/parseGradientText';

import {
  Container,
  Text,
  Buttons,
  Image,
  Video,
} from '../styles/Header.styled';

const Header = ({
  component: {
    theme,
    kickerColor,
    headingKicker,
    heading,
    subhead,
    primaryCallToAction,
    secondaryCallToAction,
    image,
    video,
    alignment,
  },
  headerRef,
}) => {
  const renderText = renderHeaderText(
    headingKicker,
    heading,
    subhead,
    primaryCallToAction,
    secondaryCallToAction
  );
  const renderMedia = renderHeaderMedia(image, video);

  if (!renderText && !renderMedia) return null;
  return (
    <Container ref={headerRef} backgroundColor={theme} alignment={alignment}>
      {renderText && (
        <Text
          theme={theme}
          alignment={alignment}
          kickerColor={kickerColor?.hex}
        >
          {headingKicker && <p className="eyebrow">{headingKicker}</p>}
          {heading && (
            <h2 className="heading">{parseGradientText(heading, '#007bff')}</h2>
          )}
          {subhead && (
            <div
              className="subhead"
              dangerouslySetInnerHTML={{ __html: subhead }}
            />
          )}
          {primaryCallToAction?.url || secondaryCallToAction?.url ? (
            <Buttons theme={theme} alignment={alignment}>
              {primaryCallToAction?.url && (
                <CallToAction
                  url={primaryCallToAction.url}
                  label={primaryCallToAction?.label}
                  classes="primary-button"
                />
              )}
              {secondaryCallToAction?.url && (
                <CallToAction
                  url={secondaryCallToAction.url}
                  label={secondaryCallToAction?.label}
                  classes="secondary-button"
                />
              )}
            </Buttons>
          ) : null}
        </Text>
      )}
      {renderMedia && (
        <>
          {(image?.image?.url || image?.image?.gatsbyImageData) && (
            <Image>
              <GatsbyImage
                src={image?.image?.url || image?.image?.gatsbyImageData}
                alt={image?.image?.alt || image?.image?.title}
                format={image?.image?.format}
                fallbackUrl={image?.image?.url}
                style={{
                  width: '100%',
                  height: 'auto',
                  margin: '0 auto',
                }}
              />
            </Image>
          )}
          {video ? <VideoComponent {...video} /> : null}
        </>
      )}
    </Container>
  );
};

export default Header;
